/**
 * LOADING OVERLAY — velo a tutto schermo con spinner, per le attese lunghe.
 *
 * Serve per le operazioni in cui l'utente non deve toccare nulla mentre si
 * aspetta, e in cui uno spinner dentro un bottone non basta perché l'attesa
 * dura troppo: il caricamento di un DXF fa girare il match di ogni riga contro
 * il catalogo del gestionale, e sono decine di secondi.
 *
 * Non è solo estetica. Bloccando il puntatore, il velo impedisce il secondo
 * click sulla stessa azione — che su un upload di DXF significherebbe due
 * importazioni sovrapposte sulle stesse righe.
 *
 * Lo sfondo resta **parzialmente visibile**: chi guarda deve continuare a
 * riconoscere la pagina su cui si trova, o l'attesa sembra un cambio di
 * schermata. È lo stesso velo del SidePanel.
 *
 * `message` è opzionale ma quasi sempre giusto: su attese di decine di secondi
 * uno spinner muto non distingue "sta lavorando" da "si è piantato". Dire che
 * cosa sta facendo è ciò che rende l'attesa accettabile.
 */

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export interface LoadingOverlayProps {
  /** Se `false` il componente non rende nulla. */
  open: boolean;
  /** Che cosa sta succedendo, in una riga. */
  message?: string;
  /** Riga secondaria, per dire quanto può durare. */
  hint?: string;
}

export function LoadingOverlay({ open, message, hint }: LoadingOverlayProps) {
  return (
    <Backdrop className="loading-overlay" open={open} aria-live="polite" aria-busy={open}>
      <div className="loading-overlay__box">
        <CircularProgress className="loading-overlay__spinner" />
        {message && <p className="loading-overlay__message">{message}</p>}
        {hint && <p className="loading-overlay__hint">{hint}</p>}
      </div>
    </Backdrop>
  );
}
